<script setup lang="ts">
type Emits = {
  close: [];
};

const emit = defineEmits<Emits>();

const base64 = defineModel<string>('modelValue', {
  default: '',
});

const base64ToSrc = computed<string>(() => {
  if (!base64.value) return '';

  return `data:application/pdf;base64,${base64.value}`;
});

const isLoadingVisible = ref<boolean>(true);

watch(base64, () => {
  if (base64ToSrc.value) {
    isLoadingVisible.value = false;
  }
});
</script>

<template>
  <BaseModal
    :custom-class-wrapper="$style.withdrawDetailsDialog"
    :model-value="true"
    :width="480"
    @close="emit('close')"
  >
    <div class="relative overflow-hidden wallet-table m-0">
      <BaseLoading
        class="!bg-auth-bg-primary"
        :show="isLoadingVisible"
        :text="$t('account.wallet.table.looking_proof')"
      />
      <iframe
        :class="$style.iframeStyle"
        height="100%"
        :src="base64ToSrc"
        width="100%"
      ></iframe>
    </div>
  </BaseModal>
</template>

<style module lang="postcss">
.withdrawDetailsDialog {
  @apply flex p-0 m-0;
}
.iframeStyle {
  @apply min-h-[100vh] md:min-h-[650px] max-w-full;
}
</style>
